import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Modal from "../../components/common/Modal";

/**
 * Opvangscherm voor een pagina die alleen op desktop bestaat.
 *
 * De mobiele router kent maar een handvol schermen. Elke andere link — de knop
 * in de updatemail landt bijvoorbeeld op `/<org>/updates?m=1` — matchte geen
 * enkele route, en een <Switch> zonder treffer rendert niets: de gebruiker
 * kreeg een wit scherm zonder uitleg. Dit scherm zegt wat er aan de hand is en
 * zet hem terug op de mobiele startpagina.
 */
const MobileUnsupportedPage = () => {
  const history = useHistory();
  const { orgId } = useParams();
  const [modalOpen, setModalOpen] = useState(true);

  const goToMobileHome = () => {
    setModalOpen(false);
    history.replace(`/${orgId}/`);
  };

  return (
    <Modal
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      pageHeader="Deze pagina werkt niet op mobiel"
      blocking
      content={
        <p>
          Deze pagina is alleen beschikbaar op een computer. Open de link op een
          desktop om verder te gaan.
        </p>
      }
      actions={
        <button onClick={goToMobileHome}>Naar de mobiele startpagina</button>
      }
    />
  );
};

export default MobileUnsupportedPage;
